import jobseekerService from "@/services/jobseekerService";
import UpSkillService from "@/services/upSkillService";

const state = {
  jobseekerData: null,
  keySkillListData: null,
  allPillarsData: null
};

const getters = {
  getJobseekerData: state => state.jobseekerData,
  getKeySkillListData: state => state.keySkillListData,
  getAllPillarsData: state => state.allPillarsData
};

const mutations = {
  setJobseekerData(state, jobseekerData) {
    state.jobseekerData = jobseekerData;
  },
  setKeySkillListData(state, keySkillListData) {
    state.keySkillListData = keySkillListData;
  },
  setAllPillarsData(state, allPillarsData) {
    state.allPillarsData = allPillarsData;
  }
};

const actions = {
  async fetchJobseekerData({ commit }) {
    const profileId = localStorage.getItem("profileId");

    let jobseekerResponse: any;

    try {
      jobseekerResponse = await jobseekerService.getJobSeekerById(profileId);

      if (
        jobseekerResponse?.status === 200 &&
        jobseekerResponse?.data?.data?.length > 0
      ) {
        commit("setJobseekerData", jobseekerResponse.data.data[0]);
      } else {
        commit("setJobseekerData", null);
      }
    } catch (error) {
      commit("setJobseekerData", null);
    }
  },

  async fetchKeySkillListData({ commit }, data: any) {
    let getAllSkillsResponse;

    try {
      getAllSkillsResponse = await UpSkillService.getAllSkills(data);

      if (
        getAllSkillsResponse?.status === 200 &&
        getAllSkillsResponse?.data?.data
      ) {
        commit("setKeySkillListData", getAllSkillsResponse.data.data);
      }
    } catch (error) {
      commit("setKeySkillListData", []);
    }
  },

  async fetchAllPillarsData({ commit }, data: any) {
    let getAllPillarsResponse;

    try {
      getAllPillarsResponse = await UpSkillService.getAllPillars(data);

      if (
        getAllPillarsResponse?.status === 200 &&
        getAllPillarsResponse?.data?.data
      ) {
        commit("setAllPillarsData", getAllPillarsResponse.data.data);
      }
    } catch (error) {
      commit("setAllPillarsData", []);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
